import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';
declare var $ :any;

import { AutosizeTextFieldComponent } from './autosize-text-field.component';

@Component({
  selector: 'app-rich-text-field',
  templateUrl: './rich-text-field.component.html',
  styleUrls: ['./rich-text-field.component.scss']
})
export class RichTextFieldComponent extends AutosizeTextFieldComponent implements OnInit {
  @Output() tabKey = new EventEmitter<null>();

  ngOnInit() {
    super.ngOnInit();
    // $.FroalaEditor.DefineIcon('bold', {NAME: 'format_bold'});
    // $.FroalaEditor.DefineIcon('italic', {NAME: 'format_italic'});
    // $.FroalaEditor.DefineIcon('outdent', {NAME: 'format_indent_decrease'});
    // $.FroalaEditor.DefineIcon('indent', {NAME: 'format_indent_increase'});
    // $.FroalaEditor.DefineIcon('formatUL', {NAME: 'format_list_bulleted'});
    // $.FroalaEditor.DefineIcon('formatOL', {NAME: 'format_list_numbered'});
    // $.FroalaEditor.DefineIconTemplate('material_design', '<mat-icon color="accent">[NAME]</mat-icon>');
    // $.FroalaEditor.ICON_DEFAULT_TEMPLATE = 'material_design';
  }

  get options(): any {
    return {
      charCounterCount: false,
      events : {
        'froalaEditor.initialized': (event, editor) => { if (this.locked) { editor.edit.off(); } },
        'froalaEditor.focus': (event) => this.onFocus(event),
        'froalaEditor.blur': (event) => this.onBlur(event),
        'froalaEditor.keydown': (event, editor, keyEvent) => this.onKey(keyEvent)
      },
      key: 'qENARBFSTb1G1QJg1RA==',
      placeholder: this.placeholder,
      theme: 'default',
      toolbarButtons: [ 'bold', 'italic', '|', 'outdent', 'indent', '|', 'formatUL', 'formatOL' ],
      htmlAllowedTags: ['p', 'br', 'ol', 'ul', 'li', 'b', 'i', 'strong', 'em'],
      htmlAllowedAttrs: ['style'],
      htmlAllowedStyleProps: ['margin-left']
    }
  }

  onKey(event): boolean {
    switch (event.keyCode) {
    case 9:
      this.tabKey.emit();
      return false;
    default: 
      return true;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/forms/rich-text-field.component.ts